class Interface {
  get() {
    throw new Error('You must implement this method');
  }

  set() {
    throw new Error('You must implement this method');
  }

  remove() {
    throw new Error('You must implement this method');
  }

  clear() {
    throw new Error('You must implement this method');
  }
}

export default Interface;


// WEBPACK FOOTER //
// ./src/common/auth/storage/drivers/Interface.js